import React, { useEffect } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./Navbar";
import AppRoutes from "./routes";
import { NotificationProvider } from "./Components/NotificationContext";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from "./context/AuthContext";
import { FavoritesProvider } from "./context/FavoritesContext";
import ErrorBoundary from "./Components/ErrorBoundary";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    const main = document.getElementById('main-content');
    if (main) main.focus({ preventScroll: true });
  }, [pathname]);
  return null;
}

function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith("/admin");

  return (
    <div>
      <a
        href="#main-content"
        style={{
          position: 'absolute',
          left: '-9999px',
          top: 'auto',
          width: '1px',
          height: '1px',
          overflow: 'hidden',
          zIndex: 9999,
        }}
        onFocus={(e) => {
          e.target.style.position = 'fixed';
          e.target.style.top = '10px';
          e.target.style.left = '10px';
          e.target.style.width = 'auto';
          e.target.style.height = 'auto';
          e.target.style.padding = '8px 16px';
          e.target.style.background = '#19474C';
          e.target.style.color = '#fff';
          e.target.style.borderRadius = '4px';
          e.target.style.textDecoration = 'none';
          e.target.style.fontSize = '14px';
        }}
        onBlur={(e) => {
          e.target.style.position = 'absolute';
          e.target.style.left = '-9999px';
          e.target.style.width = '1px';
          e.target.style.height = '1px';
        }}
      >
        Skip to main content
      </a>
      <ScrollToTop />
      {!isAdminPage && <Navbar />}
      <ErrorBoundary>
        <div id="main-content" tabIndex="-1" style={{ outline: 'none' }}>
          <AppRoutes />
        </div>
      </ErrorBoundary>
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
    <ErrorBoundary>
      <AuthProvider>
        <NotificationProvider>
          <FavoritesProvider>
            <Router>
              <AppContent />
            </Router>
            <ToastContainer />
          </FavoritesProvider>
        </NotificationProvider>
      </AuthProvider>
    </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
